import { apiRequest } from './api';

export async function fetchMyInscriptions() {
  const response = await apiRequest('/inscriptions/mes', { method: 'GET', withAuth: true });
  return response?.data ?? [];
}

export async function fetchFilieres() {
  const response = await apiRequest('/filieres', { method: 'GET', withAuth: false });
  return response?.data ?? [];
}

export async function fetchDomaines() {
  const response = await apiRequest('/domaines', { method: 'GET', withAuth: false });
  return response?.data ?? [];
}

export async function fetchPartenairesSponsors() {
  const response = await apiRequest('/partenaires-sponsors', { method: 'GET', withAuth: false });
  return response?.data ?? [];
}

export async function fetchCohortes(idFiliere) {
  const query = idFiliere ? `?idFiliere=${encodeURIComponent(idFiliere)}` : '';
  const response = await apiRequest(`/cohortes${query}`, { method: 'GET', withAuth: false });
  return response?.data ?? [];
}

export async function createInscription(idCohorte) {
  const response = await apiRequest('/inscriptions', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify({ idCohorte }),
  });
  return response?.data;
}

export async function fetchInscription(id) {
  const response = await apiRequest(`/inscriptions/${encodeURIComponent(id)}`, {
    method: 'GET',
    withAuth: true,
  });
  return response?.data;
}

export async function fetchInscriptionAcademic(id) {
  const response = await apiRequest(`/inscriptions/${encodeURIComponent(id)}/academique`, {
    method: 'GET',
    withAuth: true,
  });
  return response?.data;
}

/** Poste informatique attribué pour cette inscription (module logistique). */
export async function fetchInscriptionPoste(id) {
  const response = await apiRequest(`/inscriptions/${encodeURIComponent(id)}/poste`, {
    method: 'GET',
    withAuth: true,
  });
  return response?.data ?? null;
}

export async function fetchFormateursToEvaluate(inscriptionId) {
  const response = await apiRequest(
    `/inscriptions/${encodeURIComponent(inscriptionId)}/evaluations-formateur`,
    { method: 'GET', withAuth: true },
  );
  return response?.data ?? [];
}

export async function submitEvaluationFormateur(inscriptionId, payload) {
  const response = await apiRequest(
    `/inscriptions/${encodeURIComponent(inscriptionId)}/evaluations-formateur`,
    { method: 'POST', withAuth: true, body: JSON.stringify(payload) },
  );
  return response?.data;
}

export async function submitDepotTravail(inscriptionId, payload) {
  const response = await apiRequest(
    `/inscriptions/${encodeURIComponent(inscriptionId)}/depot-travail`,
    { method: 'POST', withAuth: true, body: JSON.stringify(payload) },
  );
  return response?.data;
}

/** Téléverse un fichier (PDF, images) et retourne le chemin `/uploads/...` pour dépôt de travail. */
export async function uploadDepotTravailFile(file) {
  const form = new FormData();
  form.append('file', file);
  const uploadRes = await apiRequest('/auth/upload-registration-document', {
    method: 'POST',
    withAuth: true,
    body: form,
  });
  const path = uploadRes?.data?.path || uploadRes?.data?.url;
  if (typeof path === 'string' && path.startsWith('/uploads/')) {
    return path;
  }
  if (typeof uploadRes?.data?.url === 'string') {
    try {
      return new URL(uploadRes.data.url).pathname;
    } catch {
      return uploadRes.data.url;
    }
  }
  throw new Error('Réponse upload invalide');
}

export async function downloadReleveNotesPdf(inscriptionId) {
  const { downloadAuthenticatedFile } = await import('./api');
  await downloadAuthenticatedFile(
    `/inscriptions/${encodeURIComponent(inscriptionId)}/releve-notes/pdf`,
    `releve-notes-${inscriptionId}.pdf`,
  );
}

export async function payerInscription(inscriptionId, payload) {
  const response = await apiRequest(`/inscriptions/${encodeURIComponent(inscriptionId)}/payer`, {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response?.data;
}

export async function reconcileInscriptionTransaction(transactionId) {
  const response = await apiRequest(
    `/inscriptions/transactions/${encodeURIComponent(transactionId)}/reconcile`,
    { method: 'POST', withAuth: true },
  );
  const data = response?.data;
  if (data && typeof data === 'object' && typeof data.statut === 'string') {
    return data.statut;
  }
  return data?.statut ?? 'EN_ATTENTE';
}

export async function fetchMyDocuments() {
  const response = await apiRequest('/profil/documents', { method: 'GET', withAuth: true });
  return response?.data ?? [];
}

export async function registerProfileDocument(payload) {
  const response = await apiRequest('/profil/documents', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response?.data;
}

export async function deleteProfileDocument(id) {
  await apiRequest(`/profil/documents/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    withAuth: true,
  });
}

export async function fetchDocumentTypes() {
  const response = await apiRequest('/profil/documents/types', { method: 'GET', withAuth: false });
  return response?.data ?? [];
}

export async function fetchFraisInscriptionStatut() {
  const response = await apiRequest('/profil/frais-inscription', { method: 'GET', withAuth: true });
  return response?.data;
}

export async function payerFraisInscription(payload) {
  const response = await apiRequest('/profil/frais-inscription/payer', {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response?.data;
}

export async function reconcileFraisInscriptionTransaction(paiementId) {
  const response = await apiRequest(
    `/profil/frais-inscription/transactions/${encodeURIComponent(paiementId)}/reconcile`,
    { method: 'POST', withAuth: true },
  );
  const data = response?.data;
  if (data && typeof data.statut === 'string') return data.statut;
  return 'EN_ATTENTE';
}

export async function fetchDossierStatut() {
  const response = await apiRequest('/profil/dossier/statut', { method: 'GET', withAuth: true });
  return response?.data;
}

export async function fetchFilierePlanning(idFiliere) {
  const response = await apiRequest(`/planning/filiere/${encodeURIComponent(idFiliere)}`, {
    method: 'GET',
    withAuth: false,
  });
  return response?.data ?? [];
}

export async function fetchPaymentConfig() {
  const response = await apiRequest('/paiement/config', { method: 'GET', withAuth: true });
  return response?.data;
}

export async function fetchFinancialHistory() {
  const response = await apiRequest('/profil/historique-financier', { method: 'GET', withAuth: true });
  return response?.data;
}

export function recuPdfApiPath(recuId) {
  return `/recus/${encodeURIComponent(recuId)}/pdf`;
}

export async function fetchElearningHub() {
  const response = await apiRequest('/elearning/hub', { method: 'GET', withAuth: true });
  return response?.data;
}

export async function fetchElearningCours(idFiliere, idCohorte) {
  const qs = new URLSearchParams({ idFiliere });
  if (idCohorte) qs.set('idCohorte', idCohorte);
  const response = await apiRequest(`/elearning/cours?${qs}`, { method: 'GET', withAuth: true });
  return response?.data ?? [];
}

export async function fetchElearningBibliotheque(idFiliere, params = {}) {
  const qs = new URLSearchParams({ idFiliere });
  if (params.q) qs.set('q', params.q);
  if (params.categorie) qs.set('categorie', params.categorie);
  if (params.tag) qs.set('tag', params.tag);
  const response = await apiRequest(`/elearning/bibliotheque?${qs}`, {
    method: 'GET',
    withAuth: true,
  });
  return response?.data ?? [];
}

export async function fetchElearningRessource(id) {
  const response = await apiRequest(`/elearning/ressources/${encodeURIComponent(id)}`, {
    method: 'GET',
    withAuth: true,
  });
  return response?.data;
}

export async function postElearningProgression(id, payload) {
  const response = await apiRequest(`/elearning/ressources/${encodeURIComponent(id)}/progression`, {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response?.data;
}

export async function submitElearningExercice(id, reponses) {
  const response = await apiRequest(`/elearning/ressources/${encodeURIComponent(id)}/reponse-exercice`, {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify({ reponses }),
  });
  return response?.data;
}

export async function fetchElearningForums(idFiliere, idCohorte) {
  const qs = new URLSearchParams({ idFiliere });
  if (idCohorte) qs.set('idCohorte', idCohorte);
  const response = await apiRequest(`/elearning/forums?${qs}`, { method: 'GET', withAuth: true });
  return response?.data ?? [];
}

export async function fetchElearningForumThread(id) {
  const response = await apiRequest(`/elearning/forums/${encodeURIComponent(id)}`, {
    method: 'GET',
    withAuth: true,
  });
  return response?.data;
}

export async function postElearningForumMessage(idForum, payload) {
  const response = await apiRequest(`/elearning/forums/${encodeURIComponent(idForum)}/messages`, {
    method: 'POST',
    withAuth: true,
    body: JSON.stringify(payload),
  });
  return response?.data;
}

export async function fetchInscriptionEvaluations(inscriptionId) {
  const response = await apiRequest(
    `/inscriptions/${encodeURIComponent(inscriptionId)}/evaluations-sessions`,
    { method: 'GET', withAuth: true },
  );
  return response?.data ?? [];
}

export async function fetchEvaluationTentative(tentativeId) {
  const response = await apiRequest(
    `/evaluations-sessions/tentatives/${encodeURIComponent(tentativeId)}`,
    { method: 'GET', withAuth: true },
  );
  return response?.data;
}

export async function startEvaluationTentative(tentativeId) {
  const response = await apiRequest(
    `/evaluations-sessions/tentatives/${encodeURIComponent(tentativeId)}/demarrer`,
    { method: 'POST', withAuth: true },
  );
  return response?.data;
}

export async function submitEvaluationTentative(tentativeId, payload) {
  const response = await apiRequest(
    `/evaluations-sessions/tentatives/${encodeURIComponent(tentativeId)}/soumettre`,
    { method: 'POST', withAuth: true, body: JSON.stringify(payload) },
  );
  return response;
}
